import { Typography } from "@mui/material";
import ComparisonTable from "./ComparisonTable";
import Section from "@/components/Section";
import {useGetProductsQuery} from "@/redux-store/api/marketingApi";

const Comparison = () => {
  // const { data: compareProducts } = useGetSimilarProductsQuery({});
  const { data: compareProducts } = useGetProductsQuery({});
  return (
    <Section pt={{ xs: 0, md: 8, lg: 13.75 }} pb={{ xs: 5, md: 8, lg: 13.75 }}>
      {compareProducts && (
        <>
          <Typography
            variant="h2"
            mb={2}
            textAlign={{ xs: "start", md: "center" }}
          >
            Find the right device
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            mb={{ xs: 3, md: 5 }}
            textAlign={{ xs: "start", md: "center" }}
          >
            Check device comparison table
          </Typography>

          <ComparisonTable compareProducts={compareProducts} />
        </>
      )}
    </Section>
  );
};

export default Comparison;
